import { FC } from 'react'
import { Divider } from 'rsuite'
import { useRouter } from 'next/router'
import { useFeatureValue } from '@growthbook/growthbook-react'
import useTranslation from 'next-translate/useTranslation'

import MobileCategoryItem from './MobileCategoryItem'
import MegaMenuSupplierIconsRow from '../MegaMenu/MegaMenuSupplierIconsRow'
import { getProductsCount } from '../../../../lib/product'
import { Catalog } from '../../../../utils/types/Product'
import useCategoryDataStructure from '../../../hooks/useCategoryDataStructure'
import { IAggregateIdentifierObject } from '../../../../utils/types/aimeosApi'
import MobileMenuItem from '../MobileUI/MobileMenuItem'
import { CatalogType } from '../../../../utils/types/misc'
import useUrls from '../../../../services/useUrls'
import useDrawerState from '../hooks/useDrawerState'

import headerStyles from '../../../../styles/Header.module.less'

interface MainCategoriesMenuProps {
  productsAggregate: IAggregateIdentifierObject[]
  setAnimationDirection: (direction: 'forward' | 'backward') => void
  setBreadcrumb: (breadcrumb: Catalog[]) => void
}

const MainCategoriesMenu: FC<MainCategoriesMenuProps> = (props) => {
  const { productsAggregate, setAnimationDirection, setBreadcrumb } = props

  const { categories } = useCategoryDataStructure()
  const { asPath } = useRouter()
  const { pushT } = useUrls()
  const { t } = useTranslation('products')

  const { toggleDrawerOpenState: toggleMobileCategoriesDrawer } = useDrawerState()

  const categoryMediaVariant = useFeatureValue<string>('category-media-variant', 'none')

  const handleCategoryClick = (category: Catalog) => {
    const productsCount = getProductsCount(productsAggregate, category)
    if (!productsCount) return

    setAnimationDirection('forward')
    setBreadcrumb([category])
  }

  const isParentCategoryActive = (categoryCode: string) => asPath.includes(categoryCode)

  const handleCatalogTabClick = (catalogType: CatalogType) => {
    const redirectUrl = `/${catalogType === 'products' ? '' : catalogType}`

    pushT(redirectUrl, undefined, { shallow: true, scroll: true })
    toggleMobileCategoriesDrawer()
  }

  const renderCatalogTab = () => (
    <MobileMenuItem
      handleClick={() => handleCatalogTabClick('suppliers')}
      hideIcon
    >
      {t('Suppliers')}
    </MobileMenuItem>
  )

  return (
    <>
      {categories.map((category) => (
        <MobileCategoryItem
          key={category.id}
          category={category}
          productsCount={getProductsCount(productsAggregate, category)}
          onCategoryClick={handleCategoryClick}
          isActive={isParentCategoryActive(category['catalog.code'])}
          categoryMediaVariant={categoryMediaVariant}
          headerStyles={headerStyles}
        />
      ))}
      <Divider className={headerStyles['supplier-menu-divider']} />
      {renderCatalogTab()}
      <MegaMenuSupplierIconsRow closeMegaMenu={toggleMobileCategoriesDrawer} />
    </>
  )
}

export default MainCategoriesMenu
